var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.processing)?_c('div',{staticClass:"upload-progress-bar"},[_c('span',{staticClass:"progress-text"},[_vm._v(_vm._s(_vm.progressNote))]),_vm._v(" "),_c('NcProgressBar',{attrs:{"value":_vm.progress,"error":_vm.hasError}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }